import React from "react";
import { Col, Row} from "reactstrap";
import * as KendoLayout from '@progress/kendo-react-layout'
import { AccentDialog } from "./AccentDialog";
import { queryNoTracking, update } from "../services/DataService";
import { accentUtils, from, t } from "../services/HelperService";
import { getProducts } from "../services/ProductService";
import { AccentButton } from "../controls/AccentButton";
import { SortListCtrl } from "../controls/SortListCtrl";
import { ReorderableList } from "../controls/SortListCtrlV2";
import { isMobileOnly } from "../controls/AccentDisplay";

const query_JobLine_SortOrderWizard = queryNoTracking("JobLine_SortOrderWizard");




export const SortJobLineDlg = props => {

    const [selectedTab, setSelectedTab] = React.useState(1);
    const [lines, setLines] = React.useState([]);
    const [products, setProducts] = React.useState([]);
  

    const handleSelect = React.useCallback(e => {
        setSelectedTab(e.selected);
    }, [setSelectedTab]);

   

    const save = React.useCallback(e => {

        update("SaveJobLineSortOrder", {
            ProductIDs: products.map(p => p.ID),
            Lines: lines.map((l, i) => {
                l.SortIndex = i;
                return l;
            })
        }).then(r => {

            props.onClose({ canceled: false });

            e.promise();
        });


    }, [ products, lines]);

    

    React.useEffect(() => {

        query_JobLine_SortOrderWizard
            .getFirstOrDefault({ jobID: props.jobID })
            .then(model => {

                setLines(from(model.Lines).orderBy(l => accentUtils.isNull(l.SortIndex) ? l.ID + 1000 : l.SortIndex).thenBy(l => l.LineNo).toArray());
                const productsByID = from(getProducts()).select(p => { return { ID: p.ID, Product: p.ProductName }; }).toDictionary(p => p.ID.toUpperCase());

                setProducts( ((model.ProductIDs.length == 0) ? from(lines).select(l => l.ProductID).distinct().toArray() : model.ProductIDs).map(p => {
                    return {
                        ID: p,
                        ProductName: productsByID.contains(p.toUpperCase()) ? productsByID.get(p.toUpperCase()).Product : "Unknown"
                    };
                }));

            });


    }, []);



    return <AccentDialog
        fullscreen
        onClose={props.onClose}
        actionLayout="end"
        actionsContent={[<AccentButton key="1" tagName="save" onClick={save}>{t("application_strings.application.buttons.save")}</AccentButton>]}
    >

        <KendoLayout.TabStrip className="emailDlg" selected={selectedTab} onSelect={handleSelect} keepTabsMounted>
            
            <KendoLayout.TabStripTab title={t("application_strings.wizards.jobLineSort.lines.title")}>
                <ReorderableList
                    key={lines.length}
                    idField="ID"
                    items={lines}
                    itemRenderer={JobLineSortLineItem}
                    onOrderChange={e => setLines(e)}                    
                />
            </KendoLayout.TabStripTab>

            <KendoLayout.TabStripTab title={t("application_strings.wizards.jobLineSort.products.title")}>
                <ReorderableList
                    key={products.length}
                    idField="ID"
                    items={products}
                    itemRenderer={JobLineSortProductItem}
                    onOrderChange={e => setProducts(e)}
                />
            </KendoLayout.TabStripTab>
        </KendoLayout.TabStrip>

    </AccentDialog>;


};




const JobLineSortLineItem = ({ item, selected, onChange }) => {

    


    return (
        <div style={{
            
        }}>
            <div
                className="row"
                style={{}}
            >
                <Col md="1">{item.LineNo}</Col>
                <Col md="2">{item.LocationOther}</Col>
                {!isMobileOnly && <Col md="3">{item.ProductName}</Col>}
                {!isMobileOnly && <Col md="2">{item.DisplayOption1}</Col>}
                {!isMobileOnly && <Col md="2">{item.DisplayOption2}</Col>}
                {!isMobileOnly && <Col md="2">{item.DisplayOption3}</Col>}

            </div>
        </div>
    );
};


const JobLineSortProductItem = ({ item, selected, onChange }) => {


    return (
        <div style={{

        }}>
            <div
                className="row"
                style={{}}
            >
                <Col md="12">{item.ProductName}</Col>
            </div>
        </div>
    );
};

